import PropTypes from 'prop-types';
import cn from 'classnames';

import Link from 'components/hf/HFLink';
import { trackEvent } from 'helpers/analytics';
import css from 'styles/components/hf/zappos/footerLang.scss';

const FooterLang = ({ handleLocaleChange, locale, hydraLocale }, { testId = () => null }) => (
  <div className={cn('OneLinkNoTx', css.footerLocale, { [css.hidden]: !hydraLocale })}>
    <h3><label htmlFor="footerLanguageSelect">Language</label></h3>
    <div className={css.iconContainer}>
      <select
        data-test-id={testId('footerLanguageSelect')}
        onChange={handleLocaleChange}
        id="footerLanguageSelect"
        name="locale"
        value={locale}
        data-source="Footer">
        <option value="en-US">English - EN</option>
        <option value="es-US">Español - ES</option>
      </select>
    </div>
    <Link
      to="/c/language-settings"
      data-test-id={testId('footerLanguageLearn')}
      onClick={() => trackEvent('TE_FOOTER_LOCALE_LEARN')}>
        Learn More
    </Link>
  </div>
);

FooterLang.contextTypes = {
  testId: PropTypes.func
};

export default FooterLang;
